export default {
  path: '/:storeId/demo/',
  component: () => import('../Index.vue'),
  children: [
    {
      path: '',
      component: () => import('../views/Home.vue'),
    },
    {
      path: 'list',
      component: () => import('../views/List.vue'),
    },
    {
      path: 'edit/:id?',
      component: () => import('../views/Edit.vue'),
    },
  ],
};
